import { CompanyTypeEnum } from 'shared/models/Client'

export const getPropertySectionNoTitle = (
  terminology: string = '',
  companyTypeCode: string = '',
  shortened: boolean = true
) => {
  if (!terminology) {
    return ''
  }

  switch (companyTypeCode) {
    case CompanyTypeEnum.BRL:
      return shortened ? `${terminology}snr` : `${terminology}snummer`
    case CompanyTypeEnum.AS:
    case CompanyTypeEnum.BAS:
      return shortened ? `${terminology}nr` : `${terminology}nummer`
    case CompanyTypeEnum.ESS:
    case CompanyTypeEnum.SA:
    case CompanyTypeEnum.TRS:
      return shortened ? `${terminology}snr` : `${terminology}snummer`
    default:
      return shortened ? 'Enhetsnr' : 'Enhetsnummer'
  }
}
